module.exports = __webpack_public_path__ + "static/media/waves.2220a02e.png";